export interface ImpersonationScreeningResponse {
  message: string
  status: number
  info: {
    count: number
  }
}

export interface StartImpersonationSearchResponse {
  message: string
  status: number
  info: {
    id: string
  }
}

export enum EImpersonationSearchStatus {
  InProgress = 'InProgress',
  Complete = 'Complete',
  Error = 'Error',
}

export interface ImpersonationSearchStatusResponse {
  message: string
  status: number
  info: {
    status: EImpersonationSearchStatus
  }
}

export interface ImpersonationProfile {
  url: string
  normalizedUrl: string
  userName: string
  platform: string
  name?: string
  image?: string
  isMatch: boolean
  similarity?: number
  isUserProvided: boolean
  source: string
}

export interface ImpersonationReport {
  _id: string
  createdAt: string
  completedAt?: string
  status: EImpersonationSearchStatus
  name: string
  profilePicUrl: string
  verifiedProfiles: ImpersonationProfile[]
  suspectedProfiles: ImpersonationProfile[]
}

export interface ImpersonationReportResponse {
  message: string
  status: number
  info: ImpersonationReport
}
